import React, { useState } from 'react';
import { connect } from 'react-redux';
//Actions
import { sendNotice } from '../actions/notice';
//Components
import LoadingModal from 'locki-dashboard-navigation/dist/loadingModal';
//Material-ui
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

function Notice({ sendNotice }) {
  const [body, setBody] = useState('');
  const [loadingModal, setLoadingModal] = useState(false);
  const [subject, setSubject] = useState('');
  function clearState() {
    setBody('');
    setSubject('');
    setLoadingModal(false);
  }
  function handleBodyChange(event) {
    setBody(event.target.value);
  }

  function handleSubjectChange(event) {
    setSubject(event.target.value);
  }
  function handleLoadingModal() {
    setLoadingModal(!loadingModal);
  }
  async function handleSend() {
    await sendNotice(body, subject);
    clearState();
  }
  return (
    <Paper className="general-paper">
      <LoadingModal
        callback={clearState}
        closeModal={handleLoadingModal}
        open={loadingModal}
        promise={handleSend}
        successLabel="Aviso enviado"
      />
      <Typography variant="h6" gutterBottom>
        Mensaje
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        Envía un mensaje a todos los vecinos.
      </Typography>
      <TextField
        label="Asunto"
        fullWidth
        margin="normal"
        value={subject}
        onChange={handleSubjectChange}
        inputProps={{ maxLength: '35' }}
      />
      <TextField
        label="Mensaje"
        multiline
        rows="8"
        fullWidth
        margin="normal"
        value={body}
        onChange={handleBodyChange}
      />
      <Button
        variant="contained"
        color="secondary"
        onClick={handleLoadingModal}
      >
        ENVIAR
      </Button>
    </Paper>
  );
}

const mapDispatchToProps = (dispatch) => ({
  sendNotice: (body, subject) => dispatch(sendNotice(body, subject)),
});

export default connect(undefined, mapDispatchToProps)(Notice);
